<template>
    <svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16 8H30C35.523 8 40 12.477 40 18V20H35L39 24L43 20H38V18C38 14.686 35.314 12 32 12H16V8ZM32 40H18C12.477 40 8 35.523 8 30V28H13L9 24L5 28H10V30C10 33.314 12.686 36 16 36H32V40Z"
            fill="none"
            stroke="currentColor"
            stroke-width="4"
            stroke-linejoin="round"
        />
    </svg>
</template>
